var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{attrs:{"title":"Administration","subtitle":"Verwalte die meinSCHWEIN Plattform"}}),_c('Content',[_c('Tabs',{attrs:{"items":_vm.tabs}}),_c('div',{staticClass:"py-2 sm:py-8"},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }